import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export const WhatsAppFloat = () => {
  const { pathname } = useLocation();

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/919755085383?text=Hello, I need information about your services', '_blank');
  };

  if (pathname.startsWith('/m') || pathname.startsWith('/admin') || pathname.startsWith('/erp')) return null;

  return (
    <div className="whatsapp-float" onClick={handleWhatsAppClick}>
      <MessageCircle size={32} strokeWidth={2.5} />
    </div>
  );
};

export default WhatsAppFloat;